import PageLayout from './common/layout/PageLayout'

function ComingSoon() {
  return (
    <PageLayout title="Coming Soon" noCard={false}>
      <div
        style={{ textAlign: 'center', padding: '3rem 0', fontSize: '1.5rem' }}
      >
        🚧 This feature is coming soon!
      </div>
    </PageLayout>
  )
}

export default ComingSoon
